import { tap } from 'rxjs/operators';

export default class UploadProgressBloc {
  constructor({ uploadProgressRepository, dialogRepository, userRepository }) {
    this.uploadProgressRepository = uploadProgressRepository;
    this.dialogRepository = dialogRepository;
    this.userRepository = userRepository;
  }

  get progress$() {
    return this.uploadProgressRepository.progress$;
  }

  get uploading$() {
    return this.uploadProgressRepository.uploading$.pipe(
      tap((uploading) => {
        if (!uploading && this.uploadProgressRepository.progress$.getValue() !== 100) {
          setTimeout(() => this.close(), 1000);
        }
      })
    );
  }

  get userDetails$() {
    return this.userRepository.userDetails$;
  }

  close() {
    this.dialogRepository.toggleDialog(false);
  }
}
